





















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalRecalcularRepasse extends Vue {
  loadExcluirItem: boolean = false

  get modalRecalcularRepasse() { return this.getFinanceiroStore.modal.recalcularRepasse }
  set modalRecalcularRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'recalcularRepasse', value }) }

  get loadingRecalcularRepasses() { return this.loadExcluirItem }
  set loadingRecalcularRepasses(value: boolean) { this.loadExcluirItem = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  async recalcularRepasse() {
    this.loadingRecalcularRepasses = true
    // Selecao pode misturar itens de valor fixo (regra propria) e procedimentos comuns:
    // cada grupo vai para o endpoint certo, nao existe mais um "ou outro" unico.
    const respostas: any[] = await Promise.all([
      this.getFinanceiroStore.recalcularItensRegraValorFixo(),
      this.getFinanceiroStore.enfileirar(),
    ])
    const respostaComErro = respostas.find(resposta => !resposta.success)
    if (!respostaComErro) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Repasses recalculados com sucesso!', icon: 'done', color: '#2E7D32' })
      this.modalRecalcularRepasse = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: respostaComErro.message || 'Ocorreu um erro ao recalcular os repasses.', icon: 'warning', color: '#C62828' })
    }
    this.loadingRecalcularRepasses = false
  }

  @Watch('modalRecalcularRepasse')
  onModalRecalcularRepasseChange(value: boolean) {
    if (!value) {
      const id = this.getFinanceiroStore.idForLoadItensRepasse
      this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    }
  }
}
